import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const theme = {
  primaryDark: "#1b325f", primaryBlue: "#282f81", accentCyan: "#11abea",
  bgLight: "#f8fafc", cardBg: "#ffffff", textMain: "#334155",
  textMuted: "#64748b", borderLight: "#e2e8f0", tableBorder: "#caced5"
};

const StockEntryMRN = ({ screenAction, triggerSave }) => {
  const today = new Date().toISOString().split('T')[0];

  const initHeader = {
    mrn_number: "", mrn_date: today, po_number: "", supplier_name: "", 
    invoice_number: "", invoice_date: "", payment_mode: ""
  };

  const initLine = {
    medicine_id: "", medicine_name: "", unit: "Box", batch_no: "", 
    ordered_qty: 0, pending_qty: 0, received_qty: "", free_quantity: "", 
    mfg_date: "", expiry_date: "", bin_location: ""
  };

  const [header, setHeader] = useState(initHeader);
  const [lines, setLines] = useState([initLine]);
  
  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  
  const [pendingPOs, setPendingPOs] = useState([]);
  const [medicinesList, setMedicinesList] = useState([]);

  // --- ERP COMPACT STYLES ---
  const compactRowStyle = { display: 'flex', alignItems: 'center', marginBottom: '6px' };
  const compactLabelStyle = { width: '110px', fontSize: '12px', color: theme.textMain, fontWeight: '600' };
  const compactInputStyle = { 
    flex: 1, padding: '4px 6px', fontSize: '12px', border: 'none', 
    borderBottom: `1px solid ${theme.borderLight}`, outline: 'none', 
    backgroundColor: isDisabled ? 'transparent' : '#fcfcfc' 
  };

  const cellStyle = { border: `1px solid ${theme.tableBorder}`, padding: '0', margin: '0' };
  const cellInputStyle = { width: '100%', boxSizing: 'border-box', border: 'none', padding: '6px 4px', fontSize: '11px', backgroundColor: 'transparent', outline: 'none' };
  const readOnlyCell = { ...cellInputStyle, backgroundColor: '#f1f5f9', fontWeight: '600', color: theme.textMain };


// --- DATA FETCHING ---
  const fetchBaseData = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      const [poRes, medRes] = await Promise.all([
        fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/med-po/pending?employee_id=${user.id}`), // Ensure URL matches your backend!
        fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicines/all?employee_id=${user.id}`)
      ]);
      
      const poData = await poRes.json();
      const medData = await medRes.json();
      
      // SAFETY CHECK: Force it to be an array even if the API returns an error object
      setPendingPOs(Array.isArray(poData) ? poData : []);
      setMedicinesList(Array.isArray(medData) ? medData : []);
      
    } catch (e) { 
      console.error("Error loading data", e);
      setPendingPOs([]);
      setMedicinesList([]);
    }
  };

  const fetchNextId = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/medicine-mrn/id?employee_id=${user.id}`);
    const data = await res.json();
    setHeader(prev => ({ ...prev, mrn_number: data.mrn_number }));
  };

  useEffect(() => { fetchBaseData(); fetchNextId(); }, []);

  // // --- HANDLE PO SELECTION ---
  // const handlePOSelect = async (e) => {
  //   const poNumber = e.target.value;
  //   setHeader({ ...header, po_number: poNumber });

  //   if (!poNumber) return;

  //   try {
  //     // Fetch the PO details to auto-fill the MRN
  //     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/med-po/${poNumber}`);
  //     const data = await res.json();
      
  //     if(data.header) {
  //       setHeader(prev => ({
  //         ...prev,
  //         supplier_name: data.header.supplier_name,
  //         invoice_number: data.header.invoice_number,
  //         invoice_date: data.header.invoice_date ? data.header.invoice_date.split('T')[0] : "",
  //         payment_mode: data.header.payment_mode
  //       }));

  //       // Map PO lines to MRN lines
  //       const mrnLines = data.details.map(d => ({
  //         medicine_id: d.medicine_id,
  //         medicine_name: d.medicine_name,
  //         unit: d.unit,
  //         batch_no: "", // User must enter batch
  //      ordered_qty: d.ordered_qty,  // 🔥 This will always be the original 200
  //         pending_qty: d.pending_qty,  // 🔥 This tracks what is left (e.g., 100)
  //         received_qty: d.pending_qty, // Default receiving to whatever is left
  //         free_quantity: d.free_quantity,
  //         mfg_date: "",
  //         expiry_date: d.expiry_date ? d.expiry_date.split('T')[0] : "",
  //         bin_location: ""
  //       }));
  //       setLines(mrnLines);
  //     }
  //   } catch (err) { console.error("Failed to fetch PO details"); }
  // };

  const handleHeaderChange = (e) => setHeader({ ...header, [e.target.name]: e.target.value });

  // const handleLineChange = (index, field, value) => {
  //   const updated = [...lines];
  //   updated[index][field] = value;

  //   if (field === "medicine_id") {
  //     const med = medicinesList.find(m => m.medicine_id === value);
  //     if (med) updated[index].medicine_name = med.medicine_name;
  //   }
  //   setLines(updated);
  // };

const handleLineChange = (index, field, value) => {
    const updated = [...lines];
    updated[index][field] = value;

    if (field === "medicine_id") {
      const med = medicinesList.find(m => m.medicine_id === value);
      if (med) updated[index].medicine_name = med.medicine_name;
    }

    // 🔥 Auto-calculate pending dynamically using our new logic!
    if (field === "received_qty") {
      const ordered = Number(updated[index].ordered_qty) || 0;
      const others = Number(updated[index].received_in_other_mrns) || 0; // What we got from other MRNs
      const received = Number(value) || 0;
      
      updated[index].pending_qty = ordered - others - received;
    }

    setLines(updated);
  };


  const addRow = () => setLines([...lines, { ...initLine }]);
  const removeRow = (index) => setLines(lines.filter((_, i) => i !== index));

  // --- SEARCH & MODES ---
  const searchMRN = async (text) => {
    setSearchText(text);
    if (text.length < 3) { setSearchResults([]); setShowDropdown(false); return; }
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-mrn/search?q=${text}&employee_id=${user.id}`);
    setSearchResults(await res.json());
    setShowDropdown(true);
  };

//   const selectMRN = async (mrn) => {
//     setSearchText(`${mrn.mrn_number} | ${mrn.supplier_name}`);
//     setShowDropdown(false);
//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-mrn/${mrn.mrn_number}`);
//     const data = await res.json();
    
//     if(data.header) {
//       setHeader({ 
//         ...data.header, 
//         mrn_date: data.header.mrn_date ? data.header.mrn_date.split('T')[0] : "",
//         invoice_date: data.header.invoice_date ? data.header.invoice_date.split('T')[0] : "" 
//       });
//       setLines(data.details.length > 0 ? data.details.map(d => ({
//         ...d, 
//         mfg_date: d.mfg_date ? d.mfg_date.split('T')[0]:"",
//         expiry_date: d.expiry_date ? d.expiry_date.split('T')[0]:""
//       })) : [initLine]);
//     }
    
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//   };

// const selectMRN = async (mrn) => {
//     setSearchText(`${mrn.mrn_number} | ${mrn.supplier_name}`);
//     setShowDropdown(false);
    
//     // IMPORTANT: Make sure this URL matches your backend port/domain!
//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-mrn/${mrn.mrn_number}`);
//     const data = await res.json();
    
//     if(data.header) {
//       setHeader({ 
//         ...data.header, 
//         mrn_date: data.header.mrn_date ? data.header.mrn_date.split('T')[0] : "",
//         invoice_date: data.header.invoice_date ? data.header.invoice_date.split('T')[0] : "" 
//       });
      
//       // 🔥 FIX: Calculate pending_qty dynamically for saved records
//       setLines(data.details.length > 0 ? data.details.map(d => ({
//         ...d, 
//         pending_qty: (d.ordered_qty || 0) - (d.received_qty || 0), // <-- Added this calculation
//         mfg_date: d.mfg_date ? d.mfg_date.split('T')[0]:"",
//         expiry_date: d.expiry_date ? d.expiry_date.split('T')[0]:""
//       })) : [initLine]);
//     }
    
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//   };

// --- HANDLE PO SELECTION (Adding new MRN) ---
  const handlePOSelect = async (e) => {
    const poNumber = e.target.value;
    setHeader({ ...header, po_number: poNumber });
    if (!poNumber) return;

    try {
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/med-po/${poNumber}`);
      const data = await res.json();
      
      if(data.header) {
        setHeader(prev => ({
          ...prev,
          supplier_name: data.header.supplier_name,
          invoice_number: data.header.invoice_number,
          invoice_date: data.header.invoice_date ? data.header.invoice_date.split('T')[0] : "",
          payment_mode: data.header.payment_mode
        }));

        const mrnLines = data.details.map(d => {
          const ord = Number(d.ordered_qty) || 0;
          const pend = Number(d.pending_qty) || 0;
          
          return {
            medicine_id: d.medicine_id,
            medicine_name: d.medicine_name,
            unit: d.unit,
            batch_no: "", 
            ordered_qty: ord,  
           received_in_other_mrns: ord - pend, // Calculate what was already received
            pending_qty: pend, // 🔥 Show the full pending amount initially
            received_qty: "",  // 🔥 Leave blank so the user MUST type it manually
            free_quantity: d.free_quantity,
            mfg_date: "",
            expiry_date: d.expiry_date ? d.expiry_date.split('T')[0] : "",
            bin_location: ""
          };
        });
        setLines(mrnLines);
      }
    } catch (err) { console.error("Failed to fetch PO details"); }
  };

  // --- SELECT MRN (Editing/Viewing existing MRN) ---
  const selectMRN = async (mrn) => {
    setSearchText(`${mrn.mrn_number} | ${mrn.supplier_name}`);
    setShowDropdown(false);
    
    const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-mrn/${mrn.mrn_number}`);
    const data = await res.json();
    
    if(data.header) {
      setHeader({ 
        ...data.header, 
        mrn_date: data.header.mrn_date ? data.header.mrn_date.split('T')[0] : "",
        invoice_date: data.header.invoice_date ? data.header.invoice_date.split('T')[0] : "" 
      });
      
      setLines(data.details.length > 0 ? data.details.map(d => ({
        ...d, 
        received_in_other_mrns: Number(d.received_in_other_mrns) || 0,
        // 🔥 MAGIC MATH: Ordered - Received Elsewhere - Received Here
        pending_qty: (Number(d.ordered_qty) || 0) - (Number(d.received_in_other_mrns) || 0) - (Number(d.received_qty) || 0), 
        mfg_date: d.mfg_date ? d.mfg_date.split('T')[0]:"",
        expiry_date: d.expiry_date ? d.expiry_date.split('T')[0]:""
      })) : [initLine]);
    }
    
    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
  };

  const clearForm = async () => {
    setHeader(initHeader); setLines([initLine]); setSearchText("");
    await fetchNextId();
    await fetchBaseData(); // Refresh pending POs
  };

  useEffect(() => {
    if (screenAction === "add" || screenAction === "refresh") { clearForm(); setIsDisabled(false); }
    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
    if (screenAction === "print") printForm();
  }, [screenAction]);

  useEffect(() => { if (triggerSave > 0 && screenAction === "save") handleSubmit(); }, [triggerSave]);

  const handleSubmit = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!header.supplier_name) return alert("Supplier is required.");
    
    const validLines = lines.filter(l => l.medicine_id !== "");
    if (validLines.length === 0) return alert("Add at least one medicine item.");

    const payload = { header: { ...header, created_by: user.id }, details: validLines, isEdit: !!header.created_at };
    
    try {
      const res = await fetch(" https://hmsapi.emedhatechnologies.com/master/api/api/medicine-mrn", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
      });
      if (res.ok) {
        alert("Material Receipt Saved! Inventory Updated.");
        if (!payload.isEdit) clearForm();
      } else alert("Error saving MRN");
    } catch (err) { alert("Network Error"); }
  };

// --- PRINT FORM ---
  const printForm = () => {
    if (!header.mrn_number) return;
    const newWindow = window.open("", "", "width=1200,height=800");
    
    const htmlContent = `
      <html><head><title>MRN - ${header.mrn_number}</title>
      <style>
        body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 30px; font-size: 12px; color: #333; }
        .title-box { display: flex; justify-content: space-between; border-bottom: 2px solid #282f81; padding-bottom: 10px; margin-bottom: 20px; }
        .title-box h1 { margin: 0; color: #282f81; font-size: 24px; text-transform: uppercase; }
        .title-box h2 { margin: 0; color: #11abea; font-size: 18px; }
        .info-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 15px; margin-bottom: 20px; padding: 15px; background-color: #f8fafc; border-left: 4px solid #282f81; border-radius: 4px; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 11px; }
        th, td { border: 1px solid #ddd; padding: 8px 4px; text-align: left; }
        th { background-color: #f2f4f4; color: #282f81; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .highlight { font-weight: bold; color: #282f81; }
        .pending { color: red; font-weight: bold; }
        
        /* Force landscape mode for printing to fit all columns perfectly */
        @media print {
          @page { size: landscape; margin: 10mm; }
          body { padding: 0; }
        }
      </style></head>
      <body>
        <div class="title-box">
          <div><h1>EMEDHA CARE HOSPITAL</h1><p>Material Receipt Note (Stock Entry)</p></div>
          <div style="text-align:right"><h2>${header.mrn_number}</h2><p>Date: ${header.mrn_date}</p></div>
        </div>
        
        <div class="info-grid">
          <div><strong>Supplier:</strong><br/>${header.supplier_name}</div>
          <div><strong>PO / Invoice:</strong><br/>${header.po_number || '-'} / ${header.invoice_number || '-'}</div>
          <div><strong>Payment Mode:</strong><br/>${header.payment_mode || '-'}</div>
        </div>
        
        <table>
          <thead>
            <tr>
              <th class="text-center">SI</th>
              <th>Medicine ID</th>
              <th>Medicine Name</th>
              <th class="text-center">Unit</th>
              <th>Batch No</th>
              <th class="text-right">Ord Qty</th>
              <th class="text-right pending">Pending</th>
              <th class="text-right highlight">Rcv Qty</th>
              <th class="text-right">Free Qty</th>
              <th>Mfg Date</th>
              <th>Expiry Dt</th>
              <th>Bin Loc</th>
            </tr>
          </thead>
          <tbody>
            ${lines.map((l, i) => `
              <tr>
                <td class="text-center">${i + 1}</td>
                <td>${l.medicine_id}</td>
                <td>${l.medicine_name}</td>
                <td class="text-center">${l.unit}</td>
                <td>${l.batch_no}</td>
                <td class="text-right">${l.ordered_qty}</td>
                <td class="text-right pending">${l.pending_qty}</td>
                <td class="text-right highlight">${l.received_qty}</td>
                <td class="text-right">${l.free_quantity}</td>
                <td>${l.mfg_date}</td>
                <td>${l.expiry_date}</td>
                <td>${l.bin_location}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        
        <div style="margin-top: 60px; display: flex; justify-content: space-between; width: 60%;">
          <div style="border-top: 1px solid #000; width: 150px; text-align:center; padding-top: 5px;">Store Manager</div>
          <div style="border-top: 1px solid #000; width: 150px; text-align:center; padding-top: 5px;">Authorized Signatory</div>
        </div>
      </body></html>
    `;
    newWindow.document.write(htmlContent); 
    newWindow.document.close();
    
    setTimeout(() => { 
      newWindow.print(); 
      newWindow.close(); 
    }, 500);
  };

  return (
    <div className="registration-container fade-in" style={{ backgroundColor: theme.bgLight, padding: '10px 20px', minHeight: '100vh' }}>
      
      {(screenAction === "edit" || screenAction === "view") && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          <div style={{ position: 'relative', width: '350px' }}>
            <input type="text" value={searchText} placeholder="Search MRN No, PO No, Supplier..." onChange={(e) => searchMRN(e.target.value)}
              style={{ width: '100%', padding: '8px 16px', borderRadius: '4px', border: `1px solid ${theme.borderLight}`, outline: 'none', fontSize: '13px' }} />
            {showDropdown && searchResults.length > 0 && (
              <div style={{ position: 'absolute', top: '105%', left: '0', width: '100%', background: theme.cardBg, border: `1px solid ${theme.borderLight}`, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, maxHeight: '200px', overflowY: 'auto' }}>
                {searchResults.map(p => (
                  <div key={p.mrn_number} onClick={() => selectMRN(p)} style={{ padding: '8px 12px', borderBottom: `1px solid ${theme.borderLight}`, cursor: 'pointer', fontSize: '12px' }}>
                    <strong style={{ color: theme.primaryDark }}>{p.mrn_number}</strong> &nbsp; | &nbsp; {p.supplier_name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <div style={{ backgroundColor: '#fff', border: `1px solid ${theme.borderLight}`, borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.02)', padding: '20px' }}>
        
        {/* ================= HEADER SECTION ================= */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px', marginBottom: '20px', paddingBottom: '15px', borderBottom: `2px solid ${theme.primaryDark}` }}>
          
          <div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>MRN Number:</div>
              <input type="text" name="mrn_number" value={header.mrn_number} disabled style={{...compactInputStyle, fontWeight: 'bold', color: theme.primaryBlue}} />
            </div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>MRN Date:</div>
              <input type="date" name="mrn_date" value={header.mrn_date} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle} />
            </div>
          </div>

          <div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Link PO No:</div>
              <select name="po_number" value={header.po_number} onChange={handlePOSelect} disabled={isDisabled || header.created_at} style={compactInputStyle}>
                <option value="">-- Select Pending PO --</option>
              {(Array.isArray(pendingPOs) ? pendingPOs : []).map((po, i) => (
                  <option key={i} value={po.po_number}>{po.po_number} ({po.supplier_name})</option>
                ))}
              </select>
            </div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Supplier Name:</div>
              <input type="text" name="supplier_name" value={header.supplier_name} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9'}} />
            </div>
          </div>

          <div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Invoice No:</div>
              <input type="text" name="invoice_number" value={header.invoice_number} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9'}} />
            </div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Invoice Date:</div>
              <input type="date" name="invoice_date" value={header.invoice_date} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9'}} />
            </div>
          </div>

        </div>

        {/* ================= LINE ITEMS DATA GRID ================= */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <h3 style={{ margin: 0, fontSize: '15px', color: theme.primaryDark }}>Stock Items</h3>
          {!isDisabled && <button type="button" onClick={addRow} style={{ background: theme.primaryBlue, color: '#fff', border: 'none', padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>+ Add Row</button>}
        </div>
        
        <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', border: `1px solid ${theme.tableBorder}` }}>
          <table style={{ width: '100%', minWidth: '1300px', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead style={{ backgroundColor: theme.primaryDark, color: '#fff' }}> 
              <tr>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '30px', textAlign: 'center' }}>SI</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '100px' }}>Medicine ID</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '180px' }}>Medicine Name</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '70px', textAlign: 'center' }}>Unit</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '100px' }}>Batch No</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '60px', textAlign: 'right' }}>Ord Qty</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '60px', textAlign: 'right', color: 'red' }}>Pending</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '60px', textAlign: 'right', color: '#fff' }}>Rcv Qty</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '60px', textAlign: 'right' }}>Free Qty</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '110px' }}>Mfg Date</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '110px' }}>Expiry Dt</th>
                <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '80px' }}>Bin Loc</th>
                {!isDisabled && <th style={{ ...cellStyle, padding: '8px 4px', minWidth: '30px' }}></th>}
              </tr>
            </thead>
            <tbody style={{ backgroundColor: '##f8fafc' }}>
              {lines.map((line, idx) => (
                <tr key={idx}>
                  <td style={{ ...cellStyle, textAlign: 'center', fontWeight: 'bold', backgroundColor: '##f8fafc' }}>{idx + 1}</td>
                  
                  <td style={cellStyle}>
                    <select value={line.medicine_id} onChange={(e) => handleLineChange(idx, 'medicine_id', e.target.value)} disabled={isDisabled} style={cellInputStyle}>
                      <option value=""></option>
                      {medicinesList.map(m => <option key={m.medicine_id} value={m.medicine_id}>{m.medicine_id}</option>)}
                    </select>
                  </td>
                  
                  <td style={cellStyle}><input type="text" value={line.medicine_name} disabled style={readOnlyCell} title={line.medicine_name} /></td>
                  
                  <td style={cellStyle}>
                    <select value={line.unit} onChange={(e) => handleLineChange(idx, 'unit', e.target.value)} disabled={isDisabled} style={{...cellInputStyle, textAlign: 'center'}}>
                      <option>Box</option><option>Strip</option><option>Loose</option>
                    </select>
                  </td>
                  
                  <td style={cellStyle}><input type="text" value={line.batch_no} onChange={(e) => handleLineChange(idx, 'batch_no', e.target.value)} disabled={isDisabled} style={cellInputStyle} placeholder="Enter Batch" /></td>
                  <td style={cellStyle}><input type="number" value={line.ordered_qty} disabled style={{...readOnlyCell, textAlign: 'right'}} /></td>
                  <td style={cellStyle}><input type="number" value={line.pending_qty} disabled style={{...readOnlyCell, textAlign: 'right', color: 'red'}} /></td>
                  <td style={cellStyle}><input type="number" value={line.received_qty} onChange={(e) => handleLineChange(idx, 'received_qty', e.target.value)} disabled={isDisabled} style={{...cellInputStyle, textAlign: 'right', fontWeight: 'bold', backgroundColor: '#fff'}} /></td>
                  
                  <td style={cellStyle}><input type="number" value={line.free_quantity} onChange={(e) => handleLineChange(idx, 'free_quantity', e.target.value)} disabled={isDisabled} style={{...cellInputStyle, textAlign: 'right'}} /></td>
                  <td style={cellStyle}><input type="date" value={line.mfg_date} onChange={(e) => handleLineChange(idx, 'mfg_date', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
                  <td style={cellStyle}><input type="date" value={line.expiry_date} onChange={(e) => handleLineChange(idx, 'expiry_date', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
                  <td style={cellStyle}><input type="text" value={line.bin_location} onChange={(e) => handleLineChange(idx, 'bin_location', e.target.value)} disabled={isDisabled} style={cellInputStyle} placeholder="e.g. A1" /></td>
                  
                  {!isDisabled && <td style={{ ...cellStyle, textAlign: 'center', backgroundColor: '#fff' }}><button type="button" onClick={() => removeRow(idx)} style={{ color: 'red', border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 'bold' }}>X</button></td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default StockEntryMRN;